import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  NUM_COLUMNS_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchemaV2NestedShapeValues,
  SHOW_DIVIDER_LINE_KEY,
  StepConfigEditorOverride,
} from '../../StepConfigEditorTypes';
import {isSeriesColumnNameNull} from '../StepConfigDisableFieldFunctions';

/**
 * Bar Chart configuration sections for the Configure tab
 */
export const BAR_CHART_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['barChartTypeSection', 'axesSection', 'seriesSection', 'errorBarsSection'],
  barChartTypeSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['barChartType'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    barChartType: {
      displayName: 'Type',
      configShapePath: ['chartConfig', 'parameters', 'barChartType'],
      editorOverride: StepConfigEditorOverride.ICON_SELECTOR,
      fieldSettings: {
        displayNames: {
          STANDARD: 'Standard',
          STACKED: 'Stacked',
        },
        svgImagePaths: {
          STANDARD: '/static/img/insights/grouped_bar_chart.svg',
          STACKED: '/static/img/insights/stacked_bar_chart.svg',
        },
      },
    },
  },
  axesSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['xAxisSection', 'yAxisSection'],
    xAxisSection: {
      displayName: 'X-axis',
      configShapePath: ['chartConfig', 'parameters', 'xAxisColumnName'],
    },
    yAxisSection: {
      displayName: 'Y-axis',
      configShapePath: ['chartConfig', 'parameters', 'yAxisColumnName'],
    },
  },
  seriesSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['seriesColumnName'],
    seriesColumnName: {
      displayName: 'Series',
      configShapePath: ['chartConfig', 'parameters', 'seriesColumnName'],
      fieldSettings: {
        allowSelectNull: true,
        noColumnSelectedText: 'None',
      },
    },
  },
  errorBarsSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['errorBarColumnName'],
    errorBarColumnName: {
      displayName: 'Error bar',
      configShapePath: ['chartConfig', 'parameters', 'errorBarColumnName'],
      fieldSettings: {
        allowSelectNull: true,
        noColumnSelectedText: 'None',
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;

/**
 * Bar Chart style sections for the Style tab
 */
export const BAR_CHART_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection', 'yAxisSection'],
  legendSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Legend',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['showLegend', 'position', 'customLabel'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    showLegend: {
      configShapePath: ['chartConfig', 'parameters', 'showLegend'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show legend',
        defaultValue: true,
      },
      disableFn: isSeriesColumnNameNull,
    },
    position: {
      displayName: 'Position',
      configShapePath: ['chartConfig', 'parameters', 'legendLocation'],
      disableFn: isSeriesColumnNameNull,
    },
    customLabel: {
      displayName: 'Custom label (optional)',
      configShapePath: ['chartConfig', 'parameters', 'legendLabel'],
      disableFn: isSeriesColumnNameNull,
    },
  },
  yAxisSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Y-axis',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['yAxisRange'],
    yAxisRange: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: ['yAxisMin', 'yAxisMax'],
      [NUM_COLUMNS_KEY]: 2,
      yAxisMin: {
        displayName: 'Min',
        configShapePath: ['chartConfig', 'parameters', 'yAxisMin'],
      },
      yAxisMax: {
        displayName: 'Max',
        configShapePath: ['chartConfig', 'parameters', 'yAxisMax'],
      },
    },
  },
} as const satisfies ShapeUISchemaV2NestedShapeValues;
